export const orderFields = [
  // "REGISTRO",
  "EQUIPO",
  "LUGAR_SERVICIO",
  // "ESTADO",
  "CLASE",
  "TIPO",
  "SOLICITANTE",
  "TELEFONO",
  "OT_PLANTA",
  "SUPERVISOR",
  "EMISION",
  "HORA_EMISION",
  // "USUARIO_ALTA",
  "DESCRIPCION",
  "CAUSA",
  // "USUARIO_CIERRE",
  // "MOMENTO_CIERRE",
  "RESPONSABLE",
  "FECHA_PLAN",
];
